import React, { Component } from 'react';
import {connect} from "react-redux";
import axios from "axios";
import { APIURL, IMAGE_FULL_URL, PORT } from '../../../config/config'
import Loading from "../../Loading";
import * as moment from 'moment';
import Swal from 'sweetalert2';
import parse from 'html-react-parser';
import { AlertSuccess } from '../../Alert/Alert';
import FinancePendingEditModal from '../FinancePendingEditModal';
import {CarSellUtil, CarsUtil} from "../../../utils/carSellUtil";
import {checkGroupPermission, getGroupPermission} from "../../../services/grouppermission";
import {format} from "date-fns";
import {border, contentBoldStyle, contentStyle, titleStyle} from "../../../utils/exceljsStyles";

// const port = window.env.PORT;


class FinancePendingList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            user: {},
            isLoading: false,
            car_id: null,
            finance_pendings: [],
            isFinancePendingEditModal: false,
            menuID: [105],
            grouppermissions: [],
            finance_statuses: [],
            finance_status_id: '0'
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.loadFinancePendingByCarId = this.loadFinancePendingByCarId.bind(this);
        this.deleteFinancialPending = this.deleteFinancialPending.bind(this);
        this.toggleFinancePendingEditModal = this.toggleFinancePendingEditModal.bind(this);
        this.onFinancePendingReload = this.onFinancePendingReload.bind(this);
        this.loadFinancePendingAll = this.loadFinancePendingAll.bind(this);
        this.loadGroupPermission = this.loadGroupPermission.bind(this);
        this.loadFinanceStatus = this.loadFinanceStatus.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    componentWillMount() {
        this.setState({
            user: JSON.parse(this.props.user)
        });
    }

    loadFinanceStatus() {
        axios.get(APIURL + '/finance_status/')
            .then(res => {
                this.setState({finance_statuses: res.data})
            }).catch(error => {
            this.setState({finance_statuses: []})
        })
    }

    loadGroupPermission() {
        let type = this.state.user.type
        let menuID = this.state.menuID
        getGroupPermission(type, menuID).then(res => {
            if(res.data.result === 'success') {
                this.setState({
                    grouppermissions: res.data.grouppermissions
                })
            }
        })
    }

    componentDidMount () {
        CarsUtil.removeCarSelect();
        CarSellUtil.removeCarSellSelect();


        const queryString = require('query-string');
        let car = queryString.parse(this.props.location.search);

        if (Object.keys(car).length !== 0) {
            this.setState({ car_id: car.car_id }, () => {
                this.loadFinancePendingByCarId(car.car_id);
            })
        } else {
            this.loadFinancePendingAll()
        }

        this.loadGroupPermission();
        this.loadFinanceStatus();

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    loadFinancePendingByCarId (car_id) {
        axios.get(APIURL + '/finance_pending/' + car_id)
          .then(res => {
              let finance_pendings = res.data
              this.setState({
                  finance_pendings: finance_pendings,
              })
          }).catch(error => {
            // alert('พบข้อผิดพลาด: ' + error)
            console.log('พบข้อผิดพลาด: ', error)
            this.setState({car: {}})
        })
    }

    loadFinancePendingAll () {
        this.setState({
            isLoading: true,
            finance_status_id: '0'
        }, () => {
            axios.get(APIURL + '/finance_pending')
                .then(res => {
                    let finance_pendings = res.data
                    this.setState({
                        finance_pendings: finance_pendings,
                        isLoading: false,
                    })
                }).catch(error => {
                // alert('พบข้อผิดพลาด: ' + error)
                console.log('พบข้อผิดพลาด: ', error)
                this.setState({car: {}})
            });
        });

    }

    onRefresh(){
        this.refs.input_search.value = ''
        this.loadFinancePendingAll()
        // this.loadData()
        // this.loadCarSellData(this.state.page)
    }

    onSearch(){
        let search_text = this.refs.input_search.value
        let finance_status_id = this.state.finance_status_id

        if(search_text.length < 3 && finance_status_id === '0') {
            if(search_text===''){
                this.loadFinancePendingAll()
                return;
            }
            return
        }


        this.setState({
            isLoading: true,
            finance_pendings: []
        }, () => {
            let data = {
                search_text: search_text,
                finance_status_id: finance_status_id
            }

            // axios.get(APIURL + '/finance_pending/search/'+search_text+'/'+finance_status_id)

            axios.post(APIURL + '/finance_pending/search', data)
                .then(res => {
                    this.setState({
                        finance_pendings: res.data,
                        is_search: true,
                        isLoading: false
                    })
                }).catch(error => {
                  console.log('error:', error)
                  this.setState({finance_pendings: []})
            })
        })
    }

    deleteFinancialPending(data) {
        const { car_id } = this.state
        let finance_pending_id = data.finance_pending_id
        let car_name = data.car_name
        let customer_name = data.customer_name + ' ' + data.customer_lastname

        Swal.fire({
            title: 'ยืนยันการลบการจัด รถ '+car_name+'\nลูกค้า '+ customer_name ,
            icon: 'warning',
            showConfirmButton: true,
            showCancelButton: true,
        }).then((result) => {
            if (result.value) {
                let url = APIURL + '/finance_pending/'+finance_pending_id
                axios.delete( url).then(res => {
                    if(res.status === 200) {
                        AlertSuccess('ลบข้อมูลเรียบร้อยแล้ว')
                        if (car_id !== null) {
                            // load by car_id
                            this.loadFinancePendingByCarId()
                        } else {
                            // load all
                        }
                    }
                }).catch(error => {
                    console.log('error:', error)
                })
            }
        })

    }

    toggleFinancePendingEditModal() {
        this.setState({
            isFinancePendingEditModal: !this.state.isFinancePendingEditModal
        })
    }

    onFinancePendingReload(car_id) {
        const queryString = require('query-string')
        let car = queryString.parse(this.props.location.search)

        if (Object.keys(car).length !== 0) {
            this.setState({
                isFinancePendingEditModal: false
            }, () => {
                this.loadFinancePendingByCarId(car.car_id)
            })
        } else {
            this.setState({
                isFinancePendingEditModal: false
            }, () => {
                this.loadFinancePendingAll()
            })
        }
        // if (car_id !== null) {
        //     // reload after edit
        //     this.setState({
        //         isFinancePendingEditModal: false
        //     }, () =>  this.loadFinancePendingByCarId(car_id))
        // } else {
        //
        // }
    }

    exportExcel() {
        let finance_pendings = this.state.finance_pendings
        // console.log(finance_pendings)

        this.setState({
            isLoading: true
        });

        let excelData = finance_pendings.map((data, index) => {
            let order = index +1

            let branch_name = data.branch_name
            let finance_date = moment(data.finance_date).locale('th').format('LL')
            let car_license_new = data.car_license_plate_new +' '+data.province_name_new
            let car_license_old = data.car_license_plate_old +' '+data.province_name_old
            let car_name = data.car_name
            let customer_fullname = data.customer_name+' '+data.customer_lastname
            // พนักงานที่จัด
            let employee_name = data.employee_name+' '+data.employee_lastname
            let finance_name = data.bank_name+'('+data.finance_contract+')'
            // ยอดจัด
            let rate_finance = data.rate_finance
            let sum_down = data.sum_down
            let monthly_installment = data.monthly_installment
            let finance_status_name = data.finance_status_name
            let finance_detail = data.finance_detail
            let finance_comment = data.finance_comment
            // ผู้ทำรายการ
            let finance_pending_user = data.finance_pending_user
            let finance_pending_date = moment(data.finance_pending_date).format('DD-MM-YYYY HH:mm:ss')

            let row = {
                order,
                branch_name,
                finance_date,
                car_name,
                car_license_new,
                car_license_old,
                customer_fullname,
                employee_name,
                finance_name,
                rate_finance,
                sum_down,
                monthly_installment,
                finance_status_name,
                finance_detail,
                finance_comment,
                finance_pending_user,
                finance_pending_date
            };
            return row
        });

        const ExcelJS = require("exceljs/dist/exceljs");
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("รายงานข้อมูลรอจัดไฟแนนซ์");

        let columns = [
            { header: "ลำดับ", key: "order", width: 6,},
            { header: "สาขาที่จัด", key: "branch_name", width: 16,},
            { header: "วันที่จัด", key: "finance_date", width: 16,},
            { header: "ข้อมูลรถ", key: "car_name", width: 22,},
            { header: "ลูกค้า", key: "customer_fullname", width: 16,},
            { header: "พนักงานที่จัด", key: "employee_name", width: 16,},
            { header: "ไฟแนนซ์", key: "finance_name", width: 18,},
            { header: "ยอดจัด", key: "rate_finance", width: 16,},
            { header: "ยอดดาวน์", key: "sum_down", width: 16,},
            { header: "ค่างวด", key: "monthly_installment", width: 16,},
            { header: "สถานะจัด", key: "finance_status_name", width: 16,},
            { header: "รายละเอียดการจัด", key: "finance_detail", width: 30,},
            { header: "หมายเหตุการจัด", key: "finance_comment", width: 30,},
            { header: "ผู้ทำรายการ", key: "finance_pending_user", width: 16,},
            { header: "รายการเมื่อ", key: "finance_pending_date", width: 16,},
        ];
        sheet.columns = columns
        let curr = format(new Date(), 'dd/MM/yyyy HH:mm:ss')
        let rows = [
            ['รายงานข้อมูลรอจัดไฟแนนซ์'],
            ['พิมพ์วันที่ : '+curr],
        ];
        sheet.insertRows(1, rows);
        // row: 3 title
        const promise = Promise.all(
            excelData.map(async (customer, index) => {
                // data แถวแรก แถวที่ 4
                let rowNumber = index + 4;
                sheet.addRow(customer)
                sheet.getRow(rowNumber).eachCell((cell, colNumber ) =>  {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.border = border;
                });

                if (rowNumber === 3) {
                    sheet.getRow(rowNumber).font = contentBoldStyle;
                } else {
                    sheet.getRow(rowNumber).font = contentStyle;
                }

            })
        );

        promise.then(() => {
            sheet.getRow(1).font = titleStyle;
            sheet.getRow(2).font = contentStyle;
            sheet.getRow(3).font = contentBoldStyle;
            sheet.getRow(3).border = border;
            sheet.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };

            workbook.xlsx.writeBuffer().then(function (data) {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                let curr = format(new Date(), 'yyyyMMdd_HHmmss');
                const fileName = 'รายงานข้อมูลรอจัดไฟแนนซ์_export_'+curr+'.xlsx';

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });

            setTimeout(() => {
                this.setState({
                    isLoading: false
                })
            } , 1200);

        });


    }

    render () {

        const {
            finance_pendings,
            finance_statuses
        } = this.state
        let width = this.state.width

        let imgWidth = ''
        if ( width >= 1340) {
            imgWidth = '220px'
        } else if (width >= 1024) {
            imgWidth = '180px'
        } else if (width >= 980) {
            imgWidth = '160px'
        } else {
            imgWidth = '140px'
        }

        let finance_statuses_list = finance_statuses.map((finance_status, index) => {
            return (
                <option key={index} value={finance_status.finance_status_id}>{finance_status.finance_status_name}</option>
            )
        });

        let tbodyEmpty = <tr><td colSpan={6} className='text-center text-danger'> ไม่พบข้อมูล </td></tr>

        let tbodyData = finance_pendings.map((data, index) => {

            let image_url = ''
            if (data.car_upload_filename.includes('https')) {
                image_url = data.car_upload_filename
            } else {
                image_url = IMAGE_FULL_URL + data.car_upload_filename
            }
            let order = index + 1

            return (
              <tr className="text-center" key={index}>
                  <td className="text-center">{order}</td>
                  <td className="text-center">
                      {moment(data.finance_date).locale('th').format('LL')}
                  </td>
                  <td>
                      <img src={image_url}
                           style={{'cursor' : 'pointer', 'width': imgWidth, 'height': 'auto'}}
                           alt="car"/>
                      <hr/>
                      {data.car_name}
                      <br/>
                      {data.car_license_plate_new} &nbsp;&nbsp; {data.province_name_new}  <br/>
                      (ทะเบียนเดิม: {data.car_license_plate_old})
                  </td>
                  <td className="text-left">
                      ลูกค้า : {data.customer_name}&nbsp;&nbsp;&nbsp;{data.customer_lastname} <br/>
                      สาขาที่จัด : {data.branch_name}  <br/>
                      พนักงานที่จัด : {data.employee_name}  {data.employee_lastname}<br/>
                      ไฟแนนซ์ : {data.bank_name} ({data.finance_contract})<br/>
                      ยอดจัด : {data.rate_finance} <br/>
                      ยอดดาวน์ : {data.sum_down === 0 ? '-' : data.sum_down} <br/>
                      ค่างวด : {data.monthly_installment === 0 ? '-' : data.monthly_installment} <br/>
                      รายละเอียดการจัด :  <br/> {data.finance_detail}

                      {
                          data.finance_comment === null ? null : (
                            <>
                                <hr/>
                                หมายเหตุการจัด :
                                <br/>
                            </>
                          )
                      }

                      {
                         data.finance_comment === null ? null : parse(data.finance_comment)
                      }
                  </td>
                  <td>
                      <span className="badge"
                            style={{backgroundColor: data.finance_status_color}}>
                      {data.finance_status_name}
                      </span>
                      <br/>
                      ผู้ทำรายการ : {data.finance_pending_user} <br/>
                      เมื่อ : {moment(data.finance_pending_date).format('DD-MM-YYYY HH:mm:ss')} <br/>

                  </td>
                  <td>
                      {
                          checkGroupPermission(105, this.state.grouppermissions).modified ? (
                              <button
                                onClick={() => {
                                    this.setState({
                                        isFinancePendingEditModal: true,
                                        finance_pending: data
                                    })
                                }}
                                type="button"
                                className={'btn btn-warning btn-sm btn-block'}
                              >
                                  <i className="icon-note">
                                      &nbsp;แก้ไข
                                  </i>
                              </button>
                          ) : null
                      }

                      {
                          checkGroupPermission(105, this.state.grouppermissions).deleted  ?
                               <button
                                 onClick={() => this.deleteFinancialPending(data)}
                                 type="button"
                                 className={'btn btn-danger btn-sm btn-block'}
                               >
                                   <i className="icon-trash">&nbsp;ลบ</i>
                               </button>
                           : null
                      }


                  </td>

              </tr>
            );
        })

        let tbodyList = finance_pendings.length === 0 ? tbodyEmpty : tbodyData

        return (

            <div className="card">

                <Loading isLoading={this.state.isLoading} />

                <FinancePendingEditModal
                  isModal={this.state.isFinancePendingEditModal}
                  toggleModal={this.toggleFinancePendingEditModal}
                  finance_pending={this.state.finance_pending}

                  onReload={this.onFinancePendingReload}
                />


                <div className="card-block">
                    <div className="row">
                        <div className="col-sm-12 col-md-12">
                            <div className="card card-accent-primary">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-9 form-inline">
                                            <strong className="text-title mr-1"> ข้อมูลรอจัดไฟแนนซ์ </strong>

                                                <select className="form-control ml-1"
                                                        id="finance_status_id"
                                                        name="finance_status_id"
                                                        value={this.state.finance_status_id}
                                                        onChange={(e)=> {
                                                            let finance_status_id = e.target.value;

                                                            this.setState({
                                                                finance_status_id: finance_status_id
                                                            });
                                                        }}
                                                >
                                                    <option value={'0'} >-เลือกสถานะ-</option>
                                                    {finance_statuses_list}
                                                </select>

                                            <input
                                                ref="input_search"
                                                style={styles.inputSearch}
                                                className="form-control"
                                                placeholder="ค้นหาตามทะเบียนรถ หรือชื่อผู้ซื้อ"
                                                type="text"
                                            />&nbsp;&nbsp;&nbsp;

                                            <button
                                                className="btn btn-sm btn-head-bar"
                                                onClick={this.onSearch.bind(this)}
                                                style={{...styles.buttonHeight, marginTop: 1 }}
                                            >
                                                <i className="icon-search"/>&nbsp; ค้นหา
                                            </button>
                                            &nbsp;

                                            <button className="btn btn-head-bar"
                                                    style={{...styles.buttonHeight, marginTop: 1 }}
                                                    onClick={this.onRefresh.bind(this)}
                                            >
                                                <i className="icon-refresh"/>
                                            </button>

                                            {
                                                checkGroupPermission(105, this.state.grouppermissions).printed ? (
                                                    <button type="button"
                                                            className="btn btn-success float-right mt-1 ml-1"
                                                            onClick={() => {
                                                                // old
                                                                // this.exportCustomerReport()
                                                                // new
                                                                this.exportExcel()
                                                            }}
                                                    >
                                                        <i className="icon-doc"/>&nbsp; Excel
                                                    </button>
                                                ) : null
                                            }

                                        </div>
                                        <div className="col-3">
                                            {
                                                PORT === 9021 ? null :
                                                    <span className="text-title float-right"> รถที่ตัดขายออก จะไม่ดึงข้อมูลมาแสดง </span>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="card-block">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{width: 10}} className="text-center">#</th>
                                                <th style={{width: 140}}  className="text-center">วันที่จัด</th>
                                                <th style={{width: 280}} className="text-center">ข้อมูลรถ</th>
                                                <th className="text-center">ข้อมูลการจัด</th>
                                                <th className="text-center">สถานะจัด</th>
                                                <th className="text-center">จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {tbodyList}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

    }

}

const styles = {
    inputSearch: {
        marginLeft: 10,
        width: 250,
        display: 'inline'
    },

    buttonHeight: {
        height: 36,
        paddingTop:0,
        paddingBottom:0,
        display: 'inline',
        marginTop: '-0.35rem'
    }
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(FinancePendingList);
